import * as React from 'react';

import { DetailsTooltipStyles } from '../../../app/spaces/CardView/DetailsTooltipStyles';
import { EntityLink, EntityLinkProps } from '../../../app/spaces/Tooltips/Elements/EntityLink';


export interface DatasourceEntityProps {
  link?: EntityLinkProps;
  fileType?: string;
  connectionDetails?: string;
  bold?: boolean;
  name?: string;
  index?: number;
}

export const DatasourceEntity = (props: DatasourceEntityProps) => {
  if(props.link){
    return (
      <div className={DetailsTooltipStyles.MetadataSection}>
        <EntityLink {...props.link}/>
        {props.index === 0 && <DetailsTooltipStyles.CartoucheConnectorLine key={props.index} />}
        <div className={DetailsTooltipStyles.TooltipMetadataValue}>{props.fileType} </div>
        {props.bold && <div className={DetailsTooltipStyles.TooltipMetadataValueHighlight}>{props.connectionDetails} </div>}
        {!props.bold && <div className={DetailsTooltipStyles.TooltipMetadataValue}>{props.connectionDetails} </div>}
      </div>
    );
  } else {
    return null;
  }
};

export const ConnectionTypeEntity = (props: DatasourceEntityProps) => {
    return (
      <div className={DetailsTooltipStyles.MetadataSection}>
        <div className={DetailsTooltipStyles.TooltipMetadataValueHeading}>{props.name} </div>
        {<div className={DetailsTooltipStyles.MetadataValue}>{props.fileType} </div>}
        {<div className={DetailsTooltipStyles.MetadataValue}>{props.connectionDetails} </div>}
      </div>
    );
};
